function carousel(name, autoplay, interval, pagination) {
    document.querySelectorAll(name).forEach(carousel => new Splide(carousel, {
        type: 'loop',
        autoplay: autoplay,
        interval: interval,
        pauseOnHover: true,
        pagination: pagination
    }).mount());
}